import React from 'react';
import PropTypes from 'prop-types';
import './CommunityContextShowMoreButton.css';
import Icon from '../../Icon/Icon';

const CommunityContextShowMoreButton = ({
  onClick,
  isDisabled,
  icon,
  text
}) => (
  <button
    styleName="button"
    type="button"
    tabbindex=""
    aria-haspopup
    disabled={isDisabled}
    onClick={!isDisabled ? onClick : () => {}}
  >
    <span styleName={text ? 'buttonItems' : ''}>
      {text && <p>{text}</p>}
      <Icon icon={icon} />
    </span>
  </button>
);

CommunityContextShowMoreButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  icon: PropTypes.arrayOf(PropTypes.string),
  text: PropTypes.string
};

CommunityContextShowMoreButton.defaultProps = {
  isDisabled: false,
  icon: ['fa', 'ellipsis-h'],
  text: null
};

export default CommunityContextShowMoreButton;
